const Mode = {
  TEST: "TEST",
  PRODUCTION: "PRODUCTION"
};

const Status = {
  PAID: "PAID",
  DUE: "DUE",
  DROPPED: "DROPPED",
  DOUBLE_SPEND: "DOUBLE_SPEND",
  LATE_SPEND: "LATE_SPEND",
  REFUNDED: "REFUNDED",
  REFUNDED_PARTIALLY: "REFUNDED_PARTIALLY"
};

const DropReason = {
  TOO_MANY_ATTEMPTS: "TOO_MANY_ATTEMPTS",
  EXPIRED: "EXPIRED",
  DROPPED_OUT: "DROPPED_OUT"
};

const Target = {
  WINDOW: "WINDOW",
  IFRAME: "IFRAME"
};

export { Status, Mode, DropReason, Target };
